// eslint-disable-next-line no-restricted-syntax
import getNextConfig from 'next/config';
import { MACRuntimeConfig } from 'env/types';

/**
 * This is an indirection layer around the NextJS 12/13 Pages Router `next/config` API which
 * has been sunset for NextJS 13 App Router. Additional context can be found here:
 *
 * https://nextjs.org/docs/pages/api-reference/next-config-js/runtime-configuration
 *
 * This preserves the same behavior as the `next/config` `getConfig` method, while allowing us
 * to eventually migrate off of next/config when we make the switch to the App Router
 */
export const getHomeLoansDashboardRuntimeConfig = (): MACRuntimeConfig => {
    const config: MACRuntimeConfig = getNextConfig();
    return config;
};
